import { createApp } from 'vue'
import RomanNumerals from './RomanNumerals.vue'
import './assets/global.css'

createApp(RomanNumerals).mount('#roman-numerals')
